export const joinPath = (pathPrefix: string, path = ''): string => {
  const normalizePrefix = (value: string) => value.replace(/^\/+|\/+$/g, '');
  const normalizePath = (value: string) => value.replace(/^\/+/, '');

  const prefix = normalizePrefix(pathPrefix);
  const trimmedPath = normalizePath(path);

  if (!prefix && !trimmedPath) {
    return '/';
  }

  if (!trimmedPath) {
    return prefix ? `/${prefix}` : '/';
  }

  if (!prefix) {
    return `/${trimmedPath}`;
  }

  return `/${prefix}/${trimmedPath}`;
};

export const toRelativePath = (path: string): string =>
  path.replace(/^\/+/, '');
